// checkHasHotel — derive whether a usable hotel is available for search.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the module-level
// `checkHasHotel` helper) as part of the behavior-preserving refactor (issue
// #240). The boolean expression — `selectedHotel`, `selectedHotel.name`, and
// `selectedHotel.name !== 'Hotel from PDF'`, coerced with `!!(...)` — is copied
// exactly, including the placeholder-name literal and operand order.
//
// Totality mirrors the source EXACTLY:
//   The leading `selectedHotel` truthiness check short-circuits before
//   `selectedHotel.name` is read, so a null/undefined `selectedHotel` yields
//   `false` exactly as the source produced. No additional guard is added.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Determine whether a real (non-placeholder) hotel is selected.
 *
 * @param {Object} selectedHotel - The selected hotel ({ name? }) or null/undefined.
 * @returns {boolean} True when a hotel with a name other than 'Hotel from PDF' exists.
 */
function checkHasHotel(selectedHotel) {
  return !!(selectedHotel && selectedHotel.name && selectedHotel.name !== 'Hotel from PDF');
}

export { checkHasHotel };
export default checkHasHotel;
